<template>
  <div class="login-component">
    <div class="title">登录您的鬼塚虎账号</div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <div class="swiper-tab">
        <div
          :class="[currentTab == index ? 'active' : '', 'swiper-tab-list']"
          @click="tapNav(index)"
          v-for="(item, index) in swiperList"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div v-if="currentTab == 0">
        <div class="input-item">
          <el-form-item prop="mobile" class="common-ipt">
            <el-input
              v-model.trim="ruleForm.mobile"
              placeholder="请输入您的手机号"
            ></el-input>
          </el-form-item>
        </div>
        <div class="input-item">
          <el-form-item prop="verifypic" class="item-left">
            <el-input
              v-model.trim="ruleForm.verifypic"
              class="verify-input"
              placeholder="请输入图形验证码"
            ></el-input>
          </el-form-item>
          <el-form-item class="item-right">
            <img class="verify-pic" :src="captchaImg" @click="refreshImg" alt />
          </el-form-item>
        </div>
        <div class="input-item">
          <el-form-item prop="code" class="item-left">
            <el-input
              v-model.trim="ruleForm.code"
              class="verify-input"
              placeholder="请输入手机验证码"
            ></el-input>
          </el-form-item>
          <el-form-item class="item-right">
            <el-button
              @click="sendSMS"
              :disabled="disableSendSMS"
              class="send-btn"
              >发送验证码{{
                `${countdown ? "(" + countdown + "s)" : ""}`
              }}</el-button
            >
          </el-form-item>
        </div>
      </div>
      <div v-else>
        <div class="input-item">
          <el-form-item prop="mobile" class="common-ipt">
            <el-input
              v-model.trim="ruleForm.mobile"
              placeholder="请输入您的手机号"
            ></el-input>
          </el-form-item>
        </div>
        <div class="input-item">
          <el-form-item prop="code" class="common-ipt">
            <el-input
              v-model="ruleForm.code"
              type="password"
              placeholder="请输入您的账户密码"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="status">
        <div class="status-l" @click="userCheck = !userCheck">
          <i :class="['iconfont', userCheck ? 'checked' : '']">{{
            userCheck ? "&#xedaf;" : "&#xec58;"
          }}</i>
          记住我的状态
        </div>
        <router-link class="status-r" :to="{ name: 'Setpassword' }"
          >忘记密码</router-link
        >
      </div>
      <el-button
        class="login-btn"
        :disabled="loginBtnStatus"
        @click="submitForm('ruleForm')"
        >登录</el-button
      >
      <div class="no-account">
        没有账号，
        <router-link
          :to="{
            name: 'Register',
            query: Object.assign(
              {},
              returnUrl || $route.query.returnUrl
                ? {
                    returnUrl: decodeURIComponent(
                      returnUrl || $route.query.returnUrl || '/'
                    ),
                  }
                : {}
            ),
          }"
        >
          <span>立即注册</span>
        </router-link>
      </div>
      <div class="others-way">
        <div>使用第三方平台登录</div>
        <div>
          <i
            v-if="enableWXLogin"
            class="iconfont wx"
            @click="toThridLogin('wx')"
            >&#xe61b;</i
          >
          <i class="iconfont webo" @click="toThridLogin('sina')">&#xe65b;</i>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils/index";

export default {
  props: {
    returnUrl: {
      type: String,
    },
  },
  data() {
    var validateCode = (rule, value, callback) => {
      if (this.currentTab == 0) {
        if (value === "") {
          callback(new Error("请输入手机验证码"));
        } else {
          callback();
        }
      } else {
        if (value === "") {
          callback(new Error("请输入密码"));
        } else {
          callback();
        }
      }
    };
    var validatePhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确格式的手机号码"));
      } else {
        callback();
      }
    };
    return {
      swiperList: ["验证码登录", "密码登录"],
      currentTab: 0,
      captchaImgSrc: api[types.CAPTCHA](),
      now: Date.now(),
      countdown: 0,
      userCheck: true,
      ruleForm: {
        mobile: localStorage.getItem("mobile"),
        verifypic: "",
        code: "",
      },
      rules: {
        mobile: [{ validator: validatePhone, trigger: "blur" }],
        verifypic: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
        code: [{ validator: validateCode, trigger: "blur" }],
      },
    };
  },
  methods: {
    tapNav(idx) {
      this.currentTab = idx;
      this.$refs["ruleForm"].resetFields();
    },
    refreshImg() {
      this.now = Date.now();
    },
    sendSMS() {
      api[types.SEND_SMS]({
        mobile: this.ruleForm.mobile,
        imgCode: this.ruleForm.verifypic,
        type: "login",
      })
        .then((res) => {
          if (res?.code == 1) {
            this.runCountdown(60, (time) => {
              this.countdown = time;
            });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    runCountdown(times, callback) {
      if (isNaN(times)) callback("倒计时定时器时间设置错误");
      callback(times);
      let timer = setInterval(() => {
        --times;
        callback(times, timer);
        if (times == 0) clearInterval(timer);
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            mobile: this.ruleForm.mobile,
            code: this.ruleForm.code,
            type: this.currentTab == 0 ? 1 : 2,
          };
          api[types.LOGIN](data)
            .then((res) => {
              if (res?.code == 1) {
                window?.gtag("event", "normal_login", {
                  send_to: process.env?.VUE_APP_GA4,
                  event_category: "normal login",
                  event_label: window.location.href,
                  login_type: this.currentTab === 0 ? "verify code" : "secret",
                });
                this.$store.commit(types.LOGIN, res.data?.token);
                this.$store.dispatch(types.GET_PROFILE);
                // 先合并游客购物车, 完成后再拉取用户购物袋(并行会有时序竞态, 把未合并数据写回)
                this.$store.dispatch(types.MERGE_CART).finally(() => {
                  this.$store.dispatch(types.GET_CART_INFO);
                });
                let returnUrl = decodeURIComponent(
                  this.returnUrl || this.$route.query?.returnUrl || "/"
                );
                this.$router.push({ path: returnUrl });
                if (this.userCheck) {
                  localStorage.setItem("mobile", data.mobile);
                } else {
                  localStorage.removeItem("mobile");
                }
              } else {
                console.warn(res);
                this.$message({
                  message: res.data.message,
                  type: "warning"
                });
              }
            })
            .catch((err) => {
              console.warn(err);
            });
        } else {
          return false;
        }
      });
    },
    // 联合登陆
    toThridLogin(channel) {
      let returnUrl = decodeURIComponent(
        this.returnUrl || this.$route.query?.returnUrl || "/"
      );
      if (channel == "wx" || channel == "sina") {
        location.href = `${api.API_PATH.replace(
          /api\/$/,
          ""
        )}${channel}/login?returnUrl=${returnUrl}`;
      } else {
        console.warn(`未知第三方登录渠道：${channel}`);
      }
    },
  },
  computed: {
    captchaImg() {
      return `${this.captchaImgSrc}?t=${this.now}`;
    },
    disableSendSMS() {
      if (this.countdown) return true;
      let { mobile, verifypic } = this.ruleForm;
      if (/^1[3456789]\d{9}$/.test(mobile) && verifypic) {
        return false;
      }
      return true;
    },
    loginBtnStatus() {
      let { currentTab, ruleForm } = this;
      if (
        (currentTab === 0 &&
          /^1[3456789]\d{9}$/.test(ruleForm.mobile) &&
          ruleForm.verifypic &&
          ruleForm.code) ||
        (currentTab === 1 &&
          /^1[3456789]\d{9}$/.test(ruleForm.mobile) &&
          ruleForm.code)
      ) {
        return false;
      }
      return true;
    },
    enableWXLogin() {
      return !utils.isMobile() && !utils.isWXBrowser();
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.item-left,
.common-ipt {
  flex: 1;
}
.login-component {
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 40px;
  }
  .swiper-tab {
    display: flex;
    height: 35px;
    color: #666;
    align-items: center;
    border-bottom: 1px solid #eee;
    margin-bottom: 30px;
    .active {
      color: #333;
      border-bottom: 2px solid #333;
    }
    .swiper-tab-list {
      width: 100%;
      height: 100%;
      text-align: center;
      cursor: pointer;
    }
  }
  .input-item {
    display: flex;
    .verify-input {
      margin-right: 10px;
    }
    .item-left {
      margin-right: 10px;
    }
    .item-right {
      width: 135px;
    }
    .verify-pic,
    .send-btn {
      width: 135px;
      height: 40px;
      padding: 0;
      cursor: pointer;
    }
    .send-btn {
      background: #fff;
      color: #999;
      border: 1px solid #ccc;
      font-size: 14px;
      border-radius: 2px;
      &[disabled] {
        color: #666;
        background: #e7e7e7;
        border: 1px solid #dcdfe6;
        cursor: not-allowed;
      }
    }
  }
  .status {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    align-items: center;
    .status-l {
      color: #000;
      font-size: 14px;
      cursor: pointer;
      .iconfont {
        color: #ccc;
      }
      .iconfont.checked {
        color: #000;
      }
    }
    .status-r {
      font-size: 14px;
      color: #666;
    }
  }
  .login-btn {
    width: 100%;
    height: 40px;
    background-color: #7f0019;
    border: 1px solid #7f0019;
    color: #fff;
    font-size: 14px;
    &[disabled] {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
  .no-account {
    font-size: 14px;
    color: #666;
    margin: 20px 0;
    span {
      color: #ae1723;
      text-decoration: underline;
    }
  }
  .others-way {
    color: #666;
    font-size: 14px;
    border-top: 1px solid #eee;
    display: flex;
    line-height: 100px;
    justify-content: space-between;
    align-items: center;
    .wx,
    .webo {
      display: inline-block;
      width: 40px;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      border-radius: 50%;
      background: #000;
      color: #fff;
      cursor: pointer;
    }
    .wx {
      margin-right: 10px;
    }
  }
}
.el-form,
.desc {
  width: 70%;
  margin: 0 auto;
}
@media only screen and (max-width: 800px) {
  .login-component {
    .title {
      font-size: 18px;
    }
    .input-item {
      display: flex;
      .verify-input {
        width: 100%;
      }
      .item-right {
        width: 135px;
      }
    }
  }
  .el-form,
  .desc {
    width: 80%;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 760px) {
  .login-component {
    .title {
      font-size: 18px;
    }
    .input-item {
      display: flex;
      .item-right {
        width: 135px;
      }
    }
  }
  .el-form,
  .desc {
    width: 80%;
    margin: 0 auto;
  }
}
</style>